import { gql, useQuery } from "@apollo/client";
import FourohFour from "@components/home/FourohFour";
import { useAuth } from "@hooks";
import { useParams } from "react-router-dom";

import Register from "./Register";

const UNAUTHENTICATED_TEAM_INVITE_QUERY = gql`
  query UnauthenticatedTeamInvite($accessToken: String!) {
    unauthenticatedTeamInvite(accessToken: $accessToken) {
      uuid
      inviteeEmail
      teamName
    }
  }
`;

export default function RegisterTeamInvite() {
  const { accessToken } = useParams();
  const { isUserAuthenticated } = useAuth();
  const { data } = useQuery(UNAUTHENTICATED_TEAM_INVITE_QUERY, {
    variables: { accessToken },
  });

  if (isUserAuthenticated) {
    return <FourohFour />;
  }

  return (
    <div>
      <Register
        isTeamInvite={true}
        teamInviteData={data}
        accessToken={accessToken}
      />
    </div>
  );
}
